export const environment = {
  production: true,
  buildId: '2542747047617621',
  configFile: 'config.json',
};
